/*eslint-disable*/
import React from "react";
import classNames from "classnames";
import PropTypes from "prop-types";
import { Form } from "react-bootstrap";
import { NavLink, useHistory } from "react-router-dom";

// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import Drawer from "@material-ui/core/Drawer";
import Hidden from "@material-ui/core/Hidden";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import Icon from "@material-ui/core/Icon";
import Box from '@mui/material/Box';

// core components
import AdminNavbarLinks from "components/Navbars/AdminNavbarLinks.js";
import RTLNavbarLinks from "components/Navbars/RTLNavbarLinks.js";
import { ExpandMore, ExpandLess } from "@material-ui/icons";
import { Collapse } from "@material-ui/core";
import styles from "assets/jss/material-dashboard-react/components/sidebarStyle.js";
import { useState } from "react";
import SyncIcon from "@material-ui/icons/Sync";
import useAuth from "hooks/useAuth";
import Button from "components/CustomButtons/Button.js";



const useStyles = makeStyles(styles);

export default function Sidebar(props) {
  const history = useHistory();
  const { garlicType, alterGarlic, user, storageId, storageIds, setStorageId, setStorageUserType, storageUserType } = useAuth();
  const [open, setOpen] = useState();
  const classes = useStyles();
  // verifies if routeName is the one active (in browser input)
  const userGarlic = user.userType !== "admin" ? user.id_admin : storageId;
  const storageName = storageIds.filter(storage => storage.id === storageId && storage.type === storageUserType);
  const handleChanged = (e) => {
    const selected_user = storageIds[e.target.value];

    setStorageId(selected_user.id);
    setStorageUserType(selected_user.type);

    const path = redirectPath(selected_user.type);
    history.push(path);
  };
  const redirectPath = (userType) => {
    let path = `/${userType}/order`;

    switch (userType) {
      case 'admin':
        path = `/${userType}/dashboard`;
        break;
      case 'operator':
        path = `/${userType}/table`;
        break;
      case 'sellsman':
        path = `/${userType}/order`;
        break;
      case 'deliveryman':
        path = `/${userType}/dashboard`;
        break;
      default:
        break;
    }

    return path;
  };
  function activeRoute(routeName) {
    return window.location.href.indexOf(routeName) > -1 ? true : false;
  }
  const { color, logo, image, routes } = props;
  var links = (
    <List className={classes.list}>
      {routes.map((prop, key) => {
        var activePro = " ";
        var listItemClasses;
        if (prop.path === "/upgrade-to-pro") {
          activePro = classes.activePro + " ";
          listItemClasses = classNames({
            [" " + classes[color]]: true,
          });
        } else {
          listItemClasses = classNames({
            [" " + classes[color]]: activeRoute(prop.layout + prop.path),
          });
        }
        const whiteFontClasses = classNames({
          [" " + classes.whiteFont]: activeRoute(prop.layout + prop.path),
        });
        return (
          <NavLink
            to={prop.layout + prop.path}
            className={activePro + classes.item}
            activeClassName="active"
            key={key}
          >
            {prop.path === "/finance" ? (
              <ListItem button onClick={(e) => setOpen(!open)}>
                {typeof prop.icon === "string" ? (
                  <Icon
                    className={classNames(classes.itemIcon, whiteFontClasses, {
                      [classes.itemIconRTL]: props.rtlActive,
                    })}
                  >
                    {prop.icon}
                  </Icon>
                ) : (
                  <prop.icon
                    className={classNames(classes.itemIcon, whiteFontClasses, {
                      [classes.itemIconRTL]: props.rtlActive,
                    })}
                  />
                )}
                <ListItemText primary="Financeiro" />
                {open ? <ExpandLess /> : <ExpandMore />}
              </ListItem>
            ) : prop.path !== "/synthetics" &&
              prop.path !== "/subsynthetic" &&
              prop.path !== "/analytical" &&
              prop.path !== "/debit" ? (
              <ListItem button className={classes.itemLink + listItemClasses}>
                {typeof prop.icon === "string" ? (
                  <Icon
                    className={classNames(classes.itemIcon, whiteFontClasses, {
                      [classes.itemIconRTL]: props.rtlActive,
                    })}
                  >
                    {prop.icon}
                  </Icon>
                ) : (
                  <prop.icon
                    className={classNames(classes.itemIcon, whiteFontClasses, {
                      [classes.itemIconRTL]: props.rtlActive,
                    })}
                  />
                )}
                <ListItemText
                  primary={props.rtlActive ? prop.rtlName : prop.name}
                  className={classNames(classes.itemText, whiteFontClasses, {
                    [classes.itemTextRTL]: props.rtlActive,
                  })}
                  disableTypography={true}
                />
              </ListItem>
            ) : (
              <></>
            )}
          </NavLink>
        );
      })}
      <Collapse in={open} timeout="auto" unmountOnExit>
        <List component="div" disablePadding>
          <NavLink
            to={"/admin/synthetics"}
            className={classes.item}
            activeClassName="active"
          >
            <ListItem button className={classes.itemLink}>
              <Icon className={classNames(classes.itemIcon)}>
                <SyncIcon />
              </Icon>
              <ListItemText
                primary={"Sintéticos"}
                className={classNames(classes.itemText)}
                disableTypography={true}
              />
            </ListItem>
          </NavLink>
          <NavLink
            to={"/admin/subsynthetic"}
            className={classes.item}
            activeClassName="active"
          >
            <ListItem button className={classes.itemLink}>
              <Icon className={classNames(classes.itemIcon)}>
                <SyncIcon />
              </Icon>
              <ListItemText
                primary={"Sub-Sintéticos"}
                className={classNames(classes.itemText)}
                disableTypography={true}
              />
            </ListItem>
          </NavLink>
          <NavLink
            to={"/admin/analytical"}
            className={classes.item}
            activeClassName="active"
          >
            <ListItem button className={classes.itemLink}>
              <Icon className={classNames(classes.itemIcon)}>
                <SyncIcon />
              </Icon>
              <ListItemText
                primary={"Analíticos"}
                className={classNames(classes.itemText)}
                disableTypography={true}
              />
            </ListItem>
          </NavLink>
          <NavLink
            to={"/admin/debit"}
            className={classes.item}
            activeClassName="active"
          >
            <ListItem button className={classes.itemLink}>
              <Icon className={classNames(classes.itemIcon)}>
                <SyncIcon />
              </Icon>
              <ListItemText
                primary={"Lançamentos"}
                className={classNames(classes.itemText)}
                disableTypography={true}
              />
            </ListItem>
          </NavLink>
        </List>
      </Collapse>
    </List>
  );
  var brand = (
    <div className={classes.logo}>
      <a
        className={classNames(classes.logoLink, {
          [classes.logoLinkRTL]: props.rtlActive,
        })}
        target="_blank"
      >
        <div className={classes.logoImage}>
          <img src={logo} alt="logo" className={classes.img} />
        </div>
        {`Santa Maria Laticinios \n ${""}`}
      </a>
      <Box sx={{ width: '100%', textAlign: 'center', color: "#fff", fontWeight: "bold", fontSize: "2em", marginTop: "1.2em", marginBottom: ".8em" }}>{storageName[0].name}</Box>
      {storageIds.length > 2 ?
        <><Form.Label>Operaçãos</Form.Label><Form.Control onChange={e => handleChanged(e)} value={storageName[0].name} as="select" defaultValue="Choose...">
          {storageIds.map((storage, index) => (
            <option key={String(index)} value={index}>{storage.name}</option>
          ))}
        </Form.Control></> : <></>
      }
      {userGarlic === 3 ?
        <div style={{ textAlign: 'center' }}>
          <Button onClick={() => alterGarlic()} >
            {garlicType === true ? "SMI" : "ALHO"}
          </Button>
        </div> : ""
      }

    </div>
  );
  return (
    <div>
      <Hidden mdUp implementation="css">
        <Drawer
          variant="temporary"
          anchor={props.rtlActive ? "left" : "right"}
          open={props.open}
          classes={{
            paper: classNames(classes.drawerPaper, {
              [classes.drawerPaperRTL]: props.rtlActive,
            }),
          }}
          onClose={props.handleDrawerToggle}
          ModalProps={{
            keepMounted: true, // Better open performance on mobile.
          }}
        >
          {brand}
          <div className={classes.sidebarWrapper}>
            {props.rtlActive ? <RTLNavbarLinks /> : <AdminNavbarLinks />}
            {links}
          </div>
          {image !== undefined ? (
            <div
              className={classes.background}
              style={{ backgroundImage: "url(" + image + ")" }}
            />
          ) : null}
        </Drawer>
      </Hidden>
      <Hidden smDown implementation="css">
        <Drawer
          anchor={props.rtlActive ? "right" : "left"}
          variant="permanent"
          open
          classes={{
            paper: classNames(classes.drawerPaper, {
              [classes.drawerPaperRTL]: props.rtlActive,
            }),
          }}
        >
          {brand}
          <div className={classes.sidebarWrapper}>{links}</div>
          {image !== undefined ? (
            <div
              className={classes.background}
              style={{ backgroundImage: "url(" + image + ")" }}
            />
          ) : null}
        </Drawer>
      </Hidden>
    </div>
  );
}

Sidebar.propTypes = {
  rtlActive: PropTypes.bool,
  handleDrawerToggle: PropTypes.func,
  bgColor: PropTypes.oneOf(["purple", "blue", "green", "orange", "red"]),
  logo: PropTypes.string,
  image: PropTypes.string,
  logoText: PropTypes.string,
  routes: PropTypes.arrayOf(PropTypes.object),
  open: PropTypes.bool,
};
